export const FORM_FIELDS_SAVED_VALUES = 'formFieldsSavedValues';

export const FORM_FIELDS_PRODUCT_SELECTOR = 'formFieldsProductSelector';
